
import { Building2, Users, Clock, BarChart } from "lucide-react";
import { DashboardFeature } from "./types";

export const venueOwnerFeatures: DashboardFeature[] = [
  {
    icon: Building2,
    title: "Venue Profile",
    description: "Manage venue details and settings",
    href: "/dashboard/venue/profile",
  },
  {
    icon: Users,
    title: "Staff Management",
    description: "Manage venue staff",
    href: "/dashboard/venue/staff",
  },
  {
    icon: Clock,
    title: "Event Calendar",
    description: "View and manage venue events",
    href: "/dashboard/venue/calendar",
  },
  {
    icon: BarChart,
    title: "Analytics",
    description: "Track venue performance",
    href: "/dashboard/venue/analytics",
  }
];
